import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { isSameDay, isSameMonth } from 'date-fns';
import { observer } from 'mobx-react';
import { useEventContext } from '../../../context/event/hooks/use-event-context';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config';
import { Icon } from '../../../subcomponents/icon/icon';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { defaultEventScheduleProps, eventSchedulePropsValidator } from './types/props';
const b = bemClassBuilder('v-event-schedule');
export const EventSchedule = observer(props => {
    const i18n = useI18n();
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { displayText, assets } = props;
    const { event } = useEventContext();
    if (!event)
        return enableSkeletonLoadingIndicators ? _jsx(EventScheduleSkeleton, {}) : null;
    const formattedSchedule = formatSchedule(event.schedule, displayText, i18n);
    if (!formattedSchedule)
        return null;
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [assets.iconName && _jsx(Icon, { name: assets.iconName, className: b.element('icon') }), _jsx("span", Object.assign({ className: b.element('label') }, { children: formattedSchedule }))] })));
});
EventSchedule.displayName = 'EventSchedule';
export const EventScheduleSkeleton = () => _jsx("div", { className: b.block({ skeleton: true }) });
EventScheduleSkeleton.displayName = 'EventScheduleSkeleton';
export const formatSchedule = (schedule, displayText, i18n) => {
    if (schedule.startDate && schedule.endDate) {
        if (isSameDay(new Date(schedule.endDate), new Date(schedule.startDate))) {
            return i18n.template(displayText.eventScheduleWithSameStartAndEndDateFormat, schedule);
        }
        if (isSameMonth(new Date(schedule.endDate), new Date(schedule.startDate))) {
            return i18n.template(displayText.eventScheduleWithSameStartAndEndMonthFormat, schedule);
        }
        return i18n.template(displayText.eventScheduleWithDifferentStartAndEndMonthFormat, schedule);
    }
    if (schedule.endDate) {
        return i18n.template(displayText.eventScheduleWithOnlyEndDateFormat, schedule);
    }
    if (schedule.startDate) {
        return i18n.template(displayText.eventScheduleWithOnlyStartDateFormat, schedule);
    }
};
/**
 * The **Event Schedule** component renders an event's schedule.
 */
export const EventScheduleComponent = withComponentWrapper(EventSchedule, defaultEventScheduleProps, eventSchedulePropsValidator);
